import { useContext } from 'react';
import { systemStatusTypes } from '@twiliointernal/services-common/components/systemStatus';

import { SystemStatusContext } from '../../providers/systemStatusProvider';

function useSystemStatus(): systemStatusTypes.SystemStatusProps {
  return useContext(SystemStatusContext);
}

export default useSystemStatus;
